export default "__VITE_ASSET__lweBkbqX__"